/* eslint-disable max-params */
/* eslint-disable @typescript-eslint/ban-ts-comment */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { useState, useEffect, useCallback } from 'react'
import { HttpResponse } from '../api/gen/http-client'
import { HTTPValidationError } from '../api/gen/data-contracts'
// import { HttpResponse } from '@/shared/api/gen/http-client'
// import { HTTPValidationError } from '@/shared/api/gen/data-contracts'

export type UseFetchProps<T> = {
	fetch: () => Promise<T>
	initialValue?: T
	dependencies: Array<any>
	options?: Partial<FetchOptions>
}

interface FetchOptions {
	autoRefresh: boolean
	refreshTiming?: number
}
const defaultOptions: FetchOptions = {
	autoRefresh: false,
	refreshTiming: 30,
}
/**
 * Хук для управления запросами
 * @param fetch - функция запроса
 * @param initialValue - значение по умолчанию
 * @param dependencies - зависимости для обновления запроса
 * @param options - дополнительные опции для запроса. Например, автообновление данных
 * @returns
 */

export function useFetch<T>(
	fetch: () => Promise<HttpResponse<T, HTTPValidationError>>,
	initialValue: T,
	dependencies: Array<any> = [],
	options: Partial<FetchOptions> = { autoRefresh: false }
) {
	const useOptions = { ...defaultOptions, ...options }

	const [data, setData] = useState<T>(initialValue)
    const [headers, setHeaders] = useState<Headers|null>(null);
	const [loading, setLoading] = useState<boolean>(true)
	const [error, setError] = useState<any | null>()
	const [isRefreshed, setIsRefreshed] = useState<boolean>(false)
	const doFetch = useCallback(() => {
		fetch()
			.then((res: HttpResponse<T, HTTPValidationError>) => {
				setLoading(false)
				setData(res?.data)
                setHeaders(res.headers)
			})
			.catch((err: any) => {
				setLoading(false)
				setError(err)
			})
	}, [...dependencies])

	const refresh = () => {
		setIsRefreshed(prev => true)
		doFetch()
	}

	useEffect(() => {
		doFetch()
	}, [doFetch])

	// eslint-disable-next-line consistent-return
	useEffect(() => {
		if (useOptions.autoRefresh) {
			const intervalID = setInterval(() => {
				setIsRefreshed((prev) => true)
				doFetch()
			}, (useOptions.refreshTiming || 30) * 1000)
			return () => {
				clearInterval(intervalID)
			}
		}
	}, [doFetch])

	return { data, headers, refresh, loading, error, isRefreshed }
}
